import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import Icon, { IconTypes } from "components/Icon/Icon"

import styles from "./faqSection.css"

export default class Section extends Component {
  static propTypes = {
    index: PropTypes.number,
    onClick: PropTypes.func,
    open: PropTypes.bool,
    section: PropTypes.object,
    titleStyle: PropTypes.string,
    descriptionStyle: PropTypes.string,
    iconStyle: PropTypes.string,
    iconRootStyle: PropTypes.string,
  }

  onClick = () => {
    this.props.onClick(this.props.index)
  }

  render() {
    const { open, section, titleStyle, descriptionStyle, iconStyle, iconRootStyle } = this.props

    const regExStrapiObject = new RegExp(/<\/[a-z]*[0-1]*>/gm)

    return (
      <div className={classNames(styles.section, { [styles.open]: open })} onClick={this.onClick}>
        <div className={styles.titleWrapper}>
          <div className={classNames(styles.title, titleStyle)}>{section.title}</div>
          <Icon type={IconTypes.chevron} iconStyle={classNames(styles.icon, iconStyle)} rootStyle={iconRootStyle} />
        </div>
        {regExStrapiObject.test(section.description) ? (
          <div className={classNames(styles.description, descriptionStyle)} dangerouslySetInnerHTML={{ __html: section.description }} />
        ) : (
          <div className={classNames(styles.description, descriptionStyle)}>{section.description}</div>
        )}
      </div>
    )
  }
}
